import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { CustomCn } from '@gate31/core/src/libs/classname';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';

export class PasswordToggle extends BaseJs {
    cn: CustomCn;

    fields: NodeListOf<HTMLInputElement>;

    constructor(options: {
        template: keyof LiquidTemplates;
        cn: CustomCn;
    }) {
        super(options.template);

        this.cn = options.cn;
        this.fields = document.querySelectorAll<HTMLInputElement>('input[type="password"]');

        this.callbackConnection();
    }

    callbackConnection() {
        this.fields.forEach(field => {
            const containerNode = this.getContainer(field);

            containerNode.classList.add(this.cn.setElem('parent').toString());

            this.renderTemplate({
                container: containerNode,
                templateData: {}
            });

            this.addEventListener(containerNode);
        });
    }

    getContainer(field: HTMLInputElement): HTMLElement {
        return field.parentNode as HTMLElement;
    }

    addEventListener(container: HTMLElement) {
        const buttonContainer = container.querySelector(this.cn.toSelector());
        const input = container.querySelector('input');

        buttonContainer?.addEventListener('click', () => {
            buttonContainer?.classList.toggle(this.cn.setMode({ hide: true }).toString());

            if (buttonContainer?.classList.contains(this.cn.setMode({ hide: true }).toString())) {
                input?.setAttribute('type', 'password');
            } else {
                input?.setAttribute('type', 'text');
            }
        });
    }
}
